import React from "react"
import { Redirect } from "react-router-dom"
import { ROUTER_GROUP, ROUTER_PRODUCT } from "helpers/router_helper"

// Authentication related pages
import Login from "pages/Authentication/Login"
import Logout from "pages/Common/Authentication/Logout"
import Register from "pages/Authentication/Register"
import ForgetPwd from "pages/Authentication/ForgetPassword"
import EmailVerification from "pages/Authentication/auth-email-verification"

// User profile
import UserProfile from "pages/Authentication/UserProfile"

//dashboard
import Dashboard from 'pages/Dashboard'

//Generate BirthChart
import BirthchartInput from "pages/BirthChart/BirthchartInput"

//BirthChartReport
import BirthChartGrid from "pages/BirthChartReport/birthchart-grid"
import BirthChartDetailView from "pages/BirthChartReport/ReportDetails/report-details"

//Report Upload
//import ReportUpload from "pages/Reports/ReportUpload"
import ReportUploadThree from "pages/Reports/ReportUploadThree"

import UserActivation from "pages/Authentication/UserActivation"
import ProductAdminLogin from "pages/ProductAdmin/Authentication/Login"
import UsersBirthChart from "pages/ProductAdmin/BirthChartReport/User/index"
import AstroUserListing from "pages/ProductAdmin/UserManagement/AstroUser/AstroUserList"
import GroupLogin from "pages/Group/Common/Authentication/Login"

// Group - Birth Details
import BirthDetailsWelcomePage from "pages/Group/User/Report/BirthDetailsWelcomePage"
import BirthDetails from "pages/Group/User/Report/BirthDetails"
import BirthDetailsNGO from "pages/Group/User/Report/BirthDetailsNGO"
import BirthDetailsLandingPage from "pages/Group/User/Report/BirthDetailsLandingPage"
import ReportsPage from "pages/Group/Common/Report/reports-page"
import ReportSummaryPage from "pages/Group/Common/Report/ReportSummary/report-summary-page"
import DashboardGroup from "pages/Group/Common/Dashboard"
import UserProfileGroup from "pages/Group/Common/UserProfile"
import Organisation from "pages/Group/Common/Organisation"
import Branches from "pages/Group/Common/Branches"
import Branch from "pages/Group/Common/Branch"
import Users from "pages/Group/Common/Users"
import GroupReportsPage from "pages/ProductAdmin/BirthChartReport/Group/index"
import BirthChartPaymentSuccess from "pages/BirthChart/BirthChartPaymentSuccess"
import BirthChartPaymentFail from "pages/BirthChart/BirthChartPaymentFail"
import BirthChartPaymentInvoice from "pages/BirthChart/BirthChartPaymentInvoice"
import Message from "pages/BirthChart/Message"
import GroupReport from "pages/Authentication/GroupReport"
import GroupReportConfirmation from "pages/Authentication/GroupReportConfirmation"

const authProtectedRoutes = [

  //profile
  { path: "/profile", component: UserProfile },
  { path: "/generate-birthchart", component: BirthchartInput },
  { path: "/birthchart-report", component: BirthChartGrid },
  { path: "/users-birthchart/:id", component: BirthChartDetailView },
  { path: "/dashboard", component: Dashboard },
  { path: "/payments/invoice", component: BirthChartPaymentInvoice },
  { path: "/payments/success/:id", component: BirthChartPaymentSuccess },
  { path: "/payments/fail", component: BirthChartPaymentFail },

  // Product Admin
  { path: `${ROUTER_PRODUCT}/dashboard`, component: Dashboard },
  { path: `${ROUTER_PRODUCT}/report-upload`, component: ReportUploadThree },
  { path: `${ROUTER_PRODUCT}/users-birthchart`, component: UsersBirthChart },
  { path: `${ROUTER_PRODUCT}/group-reports`, component: GroupReportsPage },
  { path: `${ROUTER_PRODUCT}/astrouser-list`, component: AstroUserListing },

  // Group
  { path: `${ROUTER_GROUP}/dashboard`, component: DashboardGroup },
  { path: `${ROUTER_GROUP}/profile`, component: UserProfileGroup },
  { path: `${ROUTER_GROUP}/organisation`, component: Organisation },
  { path: `${ROUTER_GROUP}/branches`, component: Branches },
  { path: `${ROUTER_GROUP}/branch`, component: Branch },
  { path: `${ROUTER_GROUP}/users`, component: Users },
  { path: `${ROUTER_GROUP}/generate-report/landing-page`, component: BirthDetailsLandingPage },
  // { path: `${ROUTER_GROUP}/generate-report`, component: BirthDetails },
  { path: `${ROUTER_GROUP}/generate-report`, component: BirthDetailsWelcomePage },
  { path: `${ROUTER_GROUP}/generate-report/NGO`, component: BirthDetailsNGO },
  { path: `${ROUTER_GROUP}/report`, component: ReportsPage },
  { path: `${ROUTER_GROUP}/report-summary/:id`, component: ReportSummaryPage },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/email-verification", component: EmailVerification },
  { path: "/activate-user/:token", component: UserActivation },

  // Product Admin
  { path: "/product/login", component: ProductAdminLogin },
  { path: `${ROUTER_GROUP}/login`, component: GroupLogin },
  { path: "/report-registration/:token", component: GroupReport },
  {path: "/report-registration-status/:token", component: GroupReportConfirmation}
]

export { authProtectedRoutes, publicRoutes }
